import React, { Component } from "react";

export class NumberFormatter extends Component {
  render() {
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);

    return <span>{value}</span>;
  }
}

export class DecimalFormatter extends Component {
  render() {
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    var text = "";
    if (!isNaN(value) && this.props.value !== "" && this.props.value != null)
      text = value.toLocaleString(undefined, { minimumFractionDigits: 2 });

    return <span>{value < 0 ? "(" + text + ")" : text}</span>;
  }
}
export class DecimalAllDigitsFormatter extends Component {
  render() {
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    var text = "";
    if (!isNaN(value) && value !== 0)
      text = value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 10,
      });

    return <span>{value < 0 ? "(" + text + ")" : text}</span>;
  }
}

export class DecimalFormatter1Digit extends Component {
  render() {
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    var text = ""; var isNegative = false;
    if (!isNaN(value) && this.props.value !== "" && this.props.value != null) {
      value = Math.round((value + Number.EPSILON) * 10) / 10;
      isNegative = (value < 0); value = Math.abs(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 1 });
    }
    return <span>{isNegative ? "(" + text + ")" : text}</span>;
  }
}

export class DecimalFormatter4Digits extends Component {
  render() {
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    var text = "";
    var isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 10000) / 10000;
      if (value < 0) isNegative = true;
      value = Math.abs(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 4 });
    }

    return <span>{isNegative ? "(" + text + ")%" : text + "%"}</span>;
  }
}
export class DecimalFormatter2Digits extends Component {
  render() {
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    var text = "";
    var isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 100) / 100;
      if (value < 0) isNegative = true;
      value = Math.abs(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 2 });
    }

    return <span>{isNegative ? "(" + text + ")" : text}</span>;
  }
}

export class DecimalFormatter4DigitsWithoutSymbol extends Component {
  render() {
    let value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    let text = "";
    let isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 10000) / 10000;
      if (value < 0) isNegative = true;
      value = Math.abs(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 4 });
    }

    return <span>{isNegative ? "(" + text + ")" : text}</span>;
  }
}
export class DecimalFormatterWithNegative extends Component {
  render() {
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    var text = "";
    var isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 100) / 100;
      if (value < 0) isNegative = true;
      value = Math.abs(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 2 });
    }

    return <span>{isNegative ? "(" + text + ")" : text}</span>;
  }
}
export class WholeNumberFormat extends Component {
  render() {
    var value = this.props.value;
    if (typeof value == 'undefined' || value == null
      || isNaN(value.toString().replace(/,/g, '').replace(/\(/g, '').replace(/\)/g, ''))) {
      value = 0;
    }
    value = Number(value.toString()
      .replace(/,/g, '').replace(/\(/g, '-').replace(/\)/g, ''));
    var text = "";
    var isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 100) / 100;
      isNegative = (value < 0);

      value = Math.abs(value);
      value = Math.round(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }

    return <span>{isNegative ? "(" + text + ")" : (this.props.value === '' ? '' : text)}</span>;
  }
}

export class WholeNumberWithNull extends Component {
  render() {
    if (this.props.value === null) {
      return 0;
    } else if (this.props.value === '') {
      return '';
    }
    else {
      var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
      var text = "";
      var isNegative = false;
      if (!isNaN(value)) {
        value = Math.round((value + Number.EPSILON) * 100) / 100;
        if (value < 0)
          isNegative = true;

        value = Math.abs(value);
        value = Math.round(value);
        text = value.toLocaleString(undefined, { minimumFractionDigits: 0 });
      }

      return <span>{isNegative ? "(" + text + ")" : text}</span>;
    }
  }
}

export class MultiLineFormat extends Component {
  render() {
    if (this.props.value == null || this.props.value == '') {
      return <span></span>;
    } else {
      if (this.props.value.includes(',')) {
        return this.props.value.split(',').map((item) => <><span>{item}</span><br /></>);
      } else {
        return <span>{this.props.value}</span>;
      }
    }
  }
}
export class MultiLineOutage extends Component {
  render() {
    if (this.props.value == null || this.props.value == '') {
      return <span></span>;
    } else {
      if (this.props.value.includes(',')) {
        return this.props.value.split(',').map((item) => {
          let s = item.split('~');
          let id = s != '' && typeof s[0] != 'undefined' ? (s[0]) : '';
          let name = s != '' && typeof s[1] != 'undefined' ? s[1] : '';
          let eid = btoa(id);
          let path = (this.props.colDef.field.includes('unplanned')
            ? '/#/UnplannedOutageSchedule/' : '/#/OutageSchedule/');
          return <><a key={1 + Math.random() * (10000 - 1)} target='_blank' rel='noopener noreferrer' href={path + eid}>{'#' + id + '-' + name}</a><br /></>
        });
      } else {
        let s = this.props.value.split('~');
        let id = s != '' && typeof s[0] != 'undefined' ? (s[0]) : '';
        let name = s != '' && typeof s[1] != 'undefined' ? s[1] : '';
        let eid = btoa(id);
        let path = (this.props.colDef.field.includes('unplanned')
          ? '/#/UnplannedOutageSchedule/' : '/#/OutageSchedule/');
        return <><a key={1 + Math.random() * (10000 - 1)} target='_blank' rel='noopener noreferrer' href={path + eid}>{'#' + id + '-' + name}</a><br /></>
      }
    }
  }
}
export const formatDecimalValue = (
  value,
  decimalPlaces = 2,
  haveBracketsForNegativeValue = false,
  isAbsoluteValue = false
) => {
  let number = isNaN(Number(value)) ? 0 : Number(value);
  let formattedValue = "";
  let isNegative = false;
  let factor = 1;
  [...Array(decimalPlaces)].forEach((_) => (factor = factor * 10)); //Get factor based on the given decimal places
  if (!isNaN(number)) {
    number = Math.round((number + Number.EPSILON) * factor) / factor;
    isNegative = number < 0;
    number = isAbsoluteValue ? Math.abs(number) : number;
    formattedValue = number.toLocaleString(undefined, {
      minimumFractionDigits: decimalPlaces,
    });
  }
  return isNegative && haveBracketsForNegativeValue
    ? `(${formattedValue})`
    : formattedValue;
};

export class PercentageFormatter extends Component {
  render() {
    let v = this.props.value;
    var value = this.props.value;
    if (typeof value == 'undefined' || value == null
      || isNaN(value.toString().replace(/,/g, '').replace(/%/g, ''))) {
      value = '';
    }
    value = Number(value.toString().replace(/,/g, '').replace(/%/g, ''));
    var text = "";
    var isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 10000) / 10000;
      if (value < 0) isNegative = true;
      value = Math.abs(value);
      value = Math.round(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }

    return <span>{isNegative ? "(" + text + "%)" : (v === null ? '' : text + "%")}</span>;
  }
}

export class PercentageFormatter1Digits extends Component {
  render() {
    let v = this.props.value;
    let product = typeof this.props.data['product'] == 'undefined' ? '' : this.props.data['product'];
    var value = this.props.value;
    if (typeof value == 'undefined' || value == null
      || isNaN(value.toString().replace(/,/g, '').replace(/%/g, ''))) {
      value = '';
    }
    value = Number(value.toString().replace(/,/g, '').replace(/%/g, ''));
    var text = "";
    var isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 10000) / 10000;
      if (value < 0) isNegative = true;
      value = Math.abs(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 1 });
    }

    return <span>{['F1', 'F2', 'F3', 'F4'].includes(product) ? '' : (isNegative ? "(" + text + "%)" : (v === null ? '' : text + "%"))}</span>;
  }
}

export class PercentageFormatter2Digits extends Component {
  render() {
    let v = this.props.value;
    var value = isNaN(Number(this.props.value)) ? 0 : Number(this.props.value);
    var text = "";
    var isNegative = false;
    if (!isNaN(value)) {
      value = Math.round((value + Number.EPSILON) * 10000) / 10000;
      if (value < 0) isNegative = true;
      value = Math.abs(value);
      text = value.toLocaleString(undefined, { minimumFractionDigits: 2 });
    }

    return <span>{isNegative ? "(" + text + "%)" : (v === null ? '' : text + "%")}</span>;
  }
}